<app-action-portal-container
	[isSaving]="isSaving"
	(onClosePortal)="onClosePortal()"
	(onClear)="clearTask()"
	(onSubmit)="submitTask()"
	[errorMessages]="errorMessages()"
	[isSaveButtonActive]="!errorMessages()"
	[title]="'vehicles|task|update-odometer-allocation|title'">
	<form class="um-section-parent-container" [formGroup]="taskFormGroup">
		<app-input-field
			formControlName="odometerValue"
			[isNumber]="true"
			[validationError]="validationErrors?.['odometerValue']"
			[label]="
				'vehicles|task|update-odometer-allocation|field-label|odometer-value'
			" />

		<app-single-dropdown
			[label]="'vehicles|task|update-odometer-allocation|field-label|reason'"
			[validationError]="validationErrors?.['changeReason']"
			[selectOptions]="odometerValueChangeReason"
			formControlName="odometerUpdateReason" />

		<app-datetime-picker
			formControlName="odometerRecordedAt"
			[label]="
				'vehicles|task|update-odometer-allocation|date-label|odometer-recorder-at'
			"
			[excludeFutureDates]="true"
			[validationError]="validationErrors?.['recordedAt']" />

		<app-free-form-input
			formControlName="notes"
			[areaTitle]="
				'vehicles|task|update-odometer-allocation|field-label|notes'
			" />
	</form>
</app-action-portal-container>
